<template>
    <div class="layout-footer">
        <div>
            <span>Bản đồ số giáo dục {{ version }} phát triển bởi </span>
            <a href="https://portal.vnpttravinh.vn" target="_blank" rel="noopener noreferrer">VNPT Trà Vinh</a>
        </div>
    </div>
</template>

<script>
import pkg from '@/package.json';

export default {
    data() {
        return {
            version: pkg.version
        };
    }
};
</script>
